// extracted by mini-css-extract-plugin
export default {"root":"bunker-badge_root__oNmuq"};